export class TimeZoneDTO {
  public timeZone: string;

  constructor() {
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
